<template lang="pug">
.success-container
  .type {{ title || "购买成功" }}
  .desc
    span 打开「
    span.high 哈啰APP
    span 」即刻出发
  .logo
    img(
      src='https://m.hellobike.com/resource/AppPlatformH5/common/EHfbjwixKXALiFPFbfDU3.png',
      alt='logo'
    )
  .ride
    .btn(@click='goApp') 去APP骑行
  .tips(v-if='!nohint')
    img(
      src='https://m.hellobike.com/resource/AppPlatformH5/common/qcGpShx2cYsAezqc64e2-.png',
      alt='warn'
    )
    span 本卡限哈啰APP使用，在非APP上用车仍会产生费用
</template>

<script>
import { getHelloCommand } from '@/api/fuli';
import { Native, env } from '@hb/NBridge/lib/h5';
import { isH5 } from '@/utils/index';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { RESULT_PAGE_ENUMS, platform, PLATFORM_APP } from './utils';

const APP_SCHEMA = 'hellobike://hellobike.com/scan_qr';

const deepLink = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true';

const startApp = (url) => Native.callNative({
  method: 'startApp',
  classMap: 'Native',
  params: {
    appId: '20000067',
    param: {
      url,
    },
  },
});

export default {
  data() {
    return {
      isH5: isH5(),
      title: '',
      source: '',
      nohint: false,
      command: null,
    };
  },
  created() {
    const {
      title, source, command, nohint,
    } = this.$route.query;
    this.title = title;
    this.source = source;
    if (nohint) {
      this.nohint = true;
    }
    if (command) {
      getHelloCommand({ commandType: '3' })
        .then((v) => v.data || {})
        .catch(() => ({}))
        .then((v) => {
          if (v) {
            this.command = v;
          }
        });
    }
    UBT.pageView({
      pageId: 'platform_success',
      categoryId: 'platform',
      businessInfo: {
        businessType: this.getBusinessType(),
      },
    });
  },
  destroyed() {
    UBT.pageViewOut({
      pageId: 'platform_success',
      categoryId: 'platform',
      businessInfo: {
        businessType: this.getBusinessType(),
      },
    });
  },
  methods: {
    getBusinessType() {
      if (this.source === RESULT_PAGE_ENUMS.UPGRADE) {
        return platform() === PLATFORM_APP ? '1' : '3';
      }
      return platform() === PLATFORM_APP ? '0' : '2';
    },
    goApp() {
      UBT.clickButton({
        pageId: 'platform_success',
        buttonName: 'platform_run',
        categoryId: 'platform',
        businessInfo: {
          businessType: this.getBusinessType(),
        },
      });
      if (env.isWechatMini) {
        window.location.href = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280';
        return;
      }
      if (env.isAliMP || env.isAliMPMonitor) {
        if (this.command) {
          Native.callNative({
            method: 'clipBoard',
            params: this.command,
          });
        }
        startApp(deepLink);
        return;
      }
      window.location.href = APP_SCHEMA;
      if (this.isH5) {
        setTimeout(() => {
          window.location.href = deepLink;
        }, 300);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.success-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 0.12rem;
  padding-top: 0.16rem;

  .logo {
    margin-bottom: 0.37rem;

    img {
      width: 100%;
    }
  }

  .type {
    font-size: 0.22rem;
    font-weight: 500;
    color: #333;
    width: 100%;
    padding-left: 0.2rem;
  }

  .desc {
    font-size: 0.15rem;
    color: #666;
    margin-top: 0.11rem;
    width: 100%;
    margin-bottom: 0.46rem;
    padding-left: 0.2rem;

    .high {
      font-size: 0.15rem;
      color: #08f;
      font-weight: bold;
    }
  }

  .ride {
    width: 100%;
    padding: 0 0.15rem;

    .btn {
      height: 0.48rem;
      line-height: 0.48rem;
      background: #08f;
      border-radius: 0.08rem;
      text-align: center;
      font-size: 0.18rem;
      color: #fff;
    }
  }

  .tips {
    width: 100%;
    color: #ff5600;
    font-size: 0.12rem;
    padding: 0.14rem 0.15rem 0 0.23rem;
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 0.12rem;
      height: 0.12rem;
      margin: 0 0.04rem 0 0;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
